import { render } from "./orderView.vue?vue&type=template&id=4a8a6e9b&scoped=true"
import script from "./orderView.vue?vue&type=script&lang=js"
export * from "./orderView.vue?vue&type=script&lang=js"

import "./orderView.vue?vue&type=style&index=0&id=4a8a6e9b&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a8a6e9b"]])

export default __exports__